<template>
  <div>
    <v-row class="pt-5">
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">เครือบริษัท</span>
        <v-autocomplete
          v-model="keywordCompanyGroup"
          :items="itemsCompanyGroup"
          item-text="groupCompanyFullname"
          item-value="groupCompanyId"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาเครือบริษัท"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordCompanyGroup='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordCompanyGroup.splice(keywordCompanyGroup.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item.groupCompanyFullname }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">บริษัท</span>
        <v-autocomplete
          v-model="keywordCompanyName"
          :items="itemsCompany"
          item-text="companyFullname"
          item-value="companyId"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาบริษัท"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordCompanyName='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordCompanyName.splice(keywordCompanyName.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item.companyFullname }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">ชื่อ service</span>
        <v-autocomplete
          v-model="keywordServiceName"
          :items="itemsServices"
          item-text="serviceName"
          item-value="_id"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="ค้นหาชื่อ service"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
          @click:clear="keywordServiceName='', searchFilterData(), page=1"
        >
        <template v-slot:selection="data">
          <v-chip
            class="mt-1 mb-1"
            color="#EFF4FD"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            close-icon="mdi-close"
            label
            filter
            small
            @click:close="keywordServiceName.splice(keywordServiceName.indexOf(data.item), 1)"
            style="color: #999999;"
          >
            <span style="color: #3776E9;">{{ data.item.serviceName }}</span>
          </v-chip>
        </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  <OverlayLoading :loading="loading" />
   <v-data-table
    class="border-table-overview mt-1"
    item-key="_id"
    :headers="headers"
    :items="dataSource"
    loading-text="Loading... Please wait"
    :footer-props="{
      'items-per-page-options': [15, 30, 50, 100, -1],
      'items-per-page': 15
    }"
    :server-items-length="total || -1"
    disable-sort
    @update:items-per-page="changePerPage"
    @update:page="changePage"
  >
    <template v-slot:[`item.no`]="{ item }">
      {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
    </template>
    <template v-slot:[`item.serviceStatus`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on">
            <v-switch
              v-model="item.isOn"
              style="transform: scale(0.8); margin-left: -15px;"
              color="primary"
              flat
              inset
              dense
              :disabled="item.globalStatus==='off'"
              readonly
              @click="onFocusServiceStatus = item, showDialogToggleStatus()"
            ></v-switch>
          </div>
        </template>
        <span class="label-table-action" v-if="item.globalStatus==='off'">Service นี้ <br>ถูกปิดการใช้งาน</span>
        <span class="label-table-action" v-else>เปิด/ปิด การใช้งาน Service <br>เมื่อปิดใช้งานจะไม่สามารถ <br>login เข้า Service นี้ได้</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            dark
            icon
            tile
            class="ra-border-button mr-4 ml-1"
            @click="clickViewService(item)"
          >
            <template v-slot>
              <v-icon dark color="primary" small>fa-eye</v-icon>
            </template>
          </v-btn>
        </template>
        <span class="label-table-action">ดูข้อมูล service</span>
      </v-tooltip>
    </template>
  </v-data-table>
  <dialogShowService/>
  <DialogRequestService :isShow='dialogReqService' @closeDialogRequestService="closeDialogRequestService()"></DialogRequestService>
  <v-dialog v-model="dialogConfirmChangeStatus" max-width="380px" persistent>
    <v-card >
      <v-card-title class="ra-head-text-bold justify-center pa-5">
        ต้องการ{{ !onFocusServiceStatus.isOn? 'เปิด':'ปิด' }}การใช้งาน Service ใช่ไหม
      </v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการ{{ !onFocusServiceStatus.isOn? 'เปิด':'ปิด' }}การใช้งาน Service นี้</span>
      </v-card-text>
      <v-card-actions class="justify-center mt-0 pb-5">
          <v-btn
            color="primary"
            outlined
            class="head-search-button mr-4"
            width="100"
            @click="dialogConfirmChangeStatus = false"
          >
          ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            class="head-search-button ml-4 white--text text--lighten-4"
            elevation="0"
            width="100"
            @click="toggleStatus(onFocusServiceStatus), dialogConfirmChangeStatus = false"
          >
          ยืนยัน
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar
    v-model="snackbar"
    :timeout="2000"
    top
    centered
    elevation="1"
    color="#ECF8EA"
    app
  >
    <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
    <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
      {{ snackbarText }}
    </span>
  </v-snackbar>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import OverlayLoading from '@/components/_template/OverlayLoading.vue'
import dialogShowService from './_dialog/dialogShowService'
import DialogRequestService from './_dialog/dialogRequestService'
import { deleteService } from '@/API/API'
const axios = require('axios')
const swal = require('sweetalert')

export default {
  name: 'tree',
  components: {
    OverlayLoading,
    dialogShowService,
    DialogRequestService
  },
  data () {
    return {
      isAdmin: (this.$store.state.user.role).includes('administrator'),
      keywordCompanyGroup: '',
      keywordCompanyName: '',
      keywordServiceName: '',
      keywordStatus: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'left',
          value: 'no',
          width: '100px',
          groupable: false,
          sortable: false
        },
        { text: 'ชื่อ Service', value: 'serviceName' },
        { text: 'เครือบริษัท', value: 'groupCompanyFullname' },
        { text: 'บริษัท', value: 'companyFullname' },
        // { text: 'isOn', value: 'isOn', width: '160' },
        { text: 'สถานะการใช้บริการ', value: 'serviceStatus', width: '160' },
        // { text: 'สถานะระบบ', value: 'globalStatusTH', width: '12%', align: 'left' },
        { text: 'จัดการ', align: 'center', width: '15%', value: 'actions', sortable: false }
      ],
      footerProps: { 'items-per-page-options': [15, 30, 50, 100, -1] },
      dataSource: [],
      total: -1,
      statusList: [
        { value: 'on', text: 'Active' },
        { value: 'off', text: 'InActive' }
      ],
      loading: true,
      perPage: 15,
      page: 1,
      itemsCompanyGroup: [],
      itemsCompany: [],
      itemsServices: [],
      dialogReqService: false,
      dialogConfirmChangeStatus: false,
      onFocusServiceStatus: '',
      snackbar: false,
      snackbarText: ''
    }
  },
  async created () {
    await this.getSelectorData()
    await this.searchFilterData()
  },
  beforeDestroy () {
    EventBus.$off('openDialogViewService')
    EventBus.$off('closeDialogViewService')
  },
  mounted () {
    EventBus.$on('closeDialogViewService', async (e) => {
      await this.searchFilterData()
    })
    EventBus.$on('openReqServiceDialog', async (e) => {
      await this.showDialogReqService()
    })
  },
  methods: {
    snackbarActive (text) {
      this.snackbarText = text
      this.snackbar = true
    },
    showDialogToggleStatus () {
      if (this.onFocusServiceStatus.globalStatus !== 'off') {
        this.dialogConfirmChangeStatus = true
      }
    },
    async showDialogReqService () {
      this.dialogReqService = true
    },
    closeDialogRequestService () {
      this.dialogReqService = false
    },
    changePerPage (value) {
      this.perPage = value
      this.searchFilterData()
    },
    changePage (value) {
      this.page = value
      this.searchFilterData()
    },
    async getSelectorData () {
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/getServiceListSelector`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              this.itemsCompanyGroup = response.data.group
              this.itemsCompany = response.data.company
              this.itemsServices = response.data.service
            } else {
              this.itemsCompanyGroup = []
              this.itemsCompany = []
              this.itemsServices = []
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
      }
    },
    async searchFilterData () {
      var self = this
      self.loading = true
      var searchKeys = {
        serviceId: this.keywordServiceName || [],
        companyId: this.keywordCompanyName || [],
        groupId: this.keywordCompanyGroup || [],
        limit: this.perPage,
        page: this.page
      }
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/getServiceList`,
          method: 'POST',
          data: searchKeys,
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              self.total = response.data.count
              self.dataSource = response.data.result
              self.dataSource.map(e => {
                e.isOn = (e.globalStatus === 'on' && e.serviceStatus === 'on')
                e.globalStatusTH = e.globalStatus === 'on' ? 'เปิดใช้งาน' : 'ปิดใช้งาน'
              })
            } else {
              self.dataSource = []
            }
          })
          .catch(function (thrown) {
            self.dataSource = []
          })
      } catch (error) { } finally {
        self.loading = false
      }
    },
    resetFilterData () {
      this.keywordServiceName = ''
      this.keywordStatus = ''
      this.searchFilterData()
    },
    async toggleStatus (item) {
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/RA/updateStatusService`,
          method: 'POST',
          data: {
            serviceStatus: item.serviceStatus === 'on' ? 'off' : 'on',
            // _id: item.requestServiceId
            _id: item._id
          },
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then((response) => {
            if (response.data.success) {
              // swal('สำเร็จ', 'เปลี่ยนสถานะสำเร็จ', 'success', {
              //   button: false,
              //   timer: 1000
              // })
              this.snackbarActive(item.serviceStatus === 'on' ? 'คุณได้ทำการปิดการใช้งาน Service เรียบร้อยแล้ว' : 'คุณได้ทำการเปิดการใช้งาน Service เรียบร้อยแล้ว')
            }
          })
      } catch (error) {
        swal('ผิดพลาด', 'เปลี่ยนสถานะไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.searchFilterData()
        this.loading = false
      }
    },
    createService () {
      // console.log('createService')
      this.$router.push('/authorityservices/myservicelist/createservice')
    },
    createRequestService () {
      // console.log('createRequestService')
      this.$router.push('/authorityservices/myservicelist/create')
    },
    clickViewService (item) {
      // console.log('clickViewService')
      // EventBus.$emit('openDialogViewService', true, item, 'view')
      this.$router.push('myservicelist/' + item._id)
    },
    clickEditService (item) {
      this.dialogEdit = true
      EventBus.$emit('openDialogViewService', true, item, 'edit')
    },
    async clickRemoveService (item) {
      swal('ยืนยันการลบ ใช่หรือไม่?', `service: ${item.serviceName} `, 'warning', {
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then(async (confirm) => {
          if (confirm) {
            // console.log('clickRemoveService', item)
            const obj = {
              serviceId: item._id
            }
            try {
              const res = await deleteService(obj, this.$store.state.token)
              if (res.success) {
                swal('สำเร็จ', 'ลบข้อมูลสำเร็จ', 'success', {
                  button: false,
                  timer: 2000
                })
              }
            } catch (error) {
              console.log(error)
              swal('ผิดพลาด', 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 2000
              })
            } finally {
              this.searchFilterData()
            }
          }
        })
    }
  }
}
</script>
<style>
.theme--light.v-input--switch.v-input--is-disabled:not(.v-input--is-dirty) .v-input--switch__track {
  /* color: red !important; */
  color: rgb(150, 150, 150) !important;
}
</style>
